import { Provider } from "react-redux";
import { useRouter } from "next/router";
import Store from "@/redux/store";
import Context from "@/context/Context";

import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import CookiesAccept from "@/components/Cookies/cookies";
import HeaderTopBar from "./Header/HeaderTopBar/HeaderTopBar";
import HeaderBanner from "./001-Main-Home/Header/Header";
import BackToTop from "@/pages/backToTop";
import WhatsAppButton from "./Button/WhatsappButton/WhatsappButton";

import Dark from "./Header/dark";
import { useUser } from "@/context/UserContext";

export default function Layout({ children }) {
  const router = useRouter();
  const isHomePage = router.pathname === '/' || router.pathname === '/landing-page' || router.pathname === '/001-main-home';
  const { user } = useUser();

  // Pages that might not need the standard header/footer (e.g., full-screen editors or specialized auth flows)
  const isAuthPage = router.pathname.startsWith('/login') || router.pathname.startsWith('/register');

  return (
    <>
      <Provider store={Store}>
        <Context>
          {!user && !isHomePage && <HeaderTopBar />}
          {isHomePage && <HeaderBanner />}

          {!isHomePage && (
            <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          )}

          <MobileMenu />
          <Cart />

          <main>{children}</main>

          <Separator />
          <FooterOne />
          <CookiesAccept />
          <WhatsAppButton />
          <Dark />
          <BackToTop />
        </Context>
      </Provider>
    </>
  );
}


